import { CompanyContractConsumptionControlledBy } from '@/features/company/types/contract.type'
import { getConsumedPercentage } from '@/features/governmentAllocations/services/getLayoutGovernmentAllocation'
import { GovernmentAllocationData } from '@/features/governmentAllocations/types/governmentAllocation.type'
import { format } from 'date-fns'
import { CircleAlertIcon, ClockIcon } from 'lucide-react'

type GovernmentAllocationCardDetailsProps = {
  governmentAllocation: GovernmentAllocationData
  hover?: boolean
  isExpired?: boolean
  controlledBy?: CompanyContractConsumptionControlledBy;
}

export const GovernmentAllocationCardDetails = ({
  governmentAllocation,
  hover,
  isExpired,
  controlledBy,
}: GovernmentAllocationCardDetailsProps) => {
  const startOfDocumentValidity = new Date(`${governmentAllocation.applicable_start_date} `)
  const endOfDocumentValidity = new Date(`${governmentAllocation.applicable_end_date} `)

  const renderGovernmentAllocationStatus = () => {
    if (governmentAllocation.status === 'pending') {
      return hover ? 'Empenho pendente' : <ClockIcon size={20} strokeWidth={1} />
    }

    if (controlledBy === CompanyContractConsumptionControlledBy.Quantity) {
      return null;
    }

    if (Number(governmentAllocation.approved_value) === 0 && !isExpired) {
      return hover ? 'Empenho sem crédito aprovado' : <CircleAlertIcon size={20} strokeWidth={1} />
    }

    const consumedPercentage = getConsumedPercentage({
      approved_value: governmentAllocation.approved_value,
      consumed_total: governmentAllocation.consumed_total,
    })

    return `${consumedPercentage}%`
  }

  return (
    <>
      <div className="border border-transparent border-l-blue-800 m-2 pl-[2px]">
        <p className="text-[10px] font-light italic leading-3">{format(startOfDocumentValidity, 'dd/MM')}</p>
        <p className="text-[10px] font-light italic leading-3">{format(endOfDocumentValidity, 'dd/MM')}</p>
      </div>

      <p className="m-2 h-5">
        {renderGovernmentAllocationStatus()}
      </p>
    </>
  )
}
